
export const GET_REQUIREMENT_LIST = 'REQUIREMENT/GET_REQUIREMENT_LIST';
export const GET_PERMIT_TYPE_LIST = 'REQUIREMENT/GET_PERMIT_TYPE_LIST';
export const UPDATE_APPLICATION_REQUIREMENT = 'REQUIREMENT/UPDATE_APPLICATION_REQUIREMENT';
